import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="cctv--camera"
export default class extends Controller {
  static values = {
    playerKey: String, exportButton: String
  }

  connect() {
  }

  async toggleCamera(event) {
    let camerasContainer = document.querySelector('#cameras_container');

    if (this.container && camerasContainer.contains(this.container)) {
      camerasContainer.removeChild(this.container);
      this.clear()
    }
    if (this.element.checked) {
      await this.buildCameraBlock(camerasContainer)
    } else {
      if (this.container && camerasContainer.contains(this.container)) {
        camerasContainer.removeChild(this.container);
        this.clear()
      }
    }
  }


  initRmp(url) {
    return {
      licenseKey: this.playerKeyValue,
      src: {
        hls: url
      },
      crossorigin: 'use-credentials',
      ajaxWithCredentials: true,
      ajaxTimeout: 30000,
      hlsJSFetchXhrWithCredentials: true,
      autoHeightMode: true,
      autoplay: true,
      speed: true,
    };
  }


  buildURLSearchParams(id, min, max) {
    return new URLSearchParams({
      camera_id: id,
      period_from: this.formatDateWithOffset(min),
      period_to: this.formatDateWithOffset(max)
    })
  }

  formatDateWithOffset(date) {
    const pad = (n) => String(n).padStart(2, "0")

    const tzOffset = -date.getTimezoneOffset() // in minutes
    const offsetSign = tzOffset >= 0 ? "+" : "-"
    const offsetHours = pad(Math.floor(Math.abs(tzOffset) / 60))
    const offsetMinutes = pad(Math.abs(tzOffset) % 60)

    return (
      date.getFullYear() +
      "-" + pad(date.getMonth() + 1) +
      "-" + pad(date.getDate()) +
      "T" + pad(date.getHours()) +
      ":" + pad(date.getMinutes()) +
      ":" + pad(date.getSeconds()) +
      offsetSign + offsetHours + ":" + offsetMinutes
    )
  }

  containerBuild(container, id) {
    container.className = 'col';
    container.id = 'camera_' + id.trim();
  }

  playerBuild(playerElement, id) {
    playerElement.className = 'card card-body shadow'
    playerElement.id = 'player_' + id.trim()
  }

  vclPlayerBuild(playerElement, id) {
    playerElement.className = 'card card-body shadow widescreen vimeo vlc_container'
    playerElement.id = 'player_' + id.trim()

    playerElement.innerHTML = `
    <object
      classid="clsid:9BE31822-FDAD-461B-AD51-BE1D1C159921"
      codebase="http://downloads.videolan.org/pub/videolan/vlc/latest/win32/axvlc.cab">
      
      <param name="Src" value="${this.rtspUrlValue}" />
      <param name="ShowDisplay" value="True" />
      <param name="AutoLoop" value="False" />
      <param name="AutoPlay" value="True" />
  
      <embed
        type="application/x-vlc-plugin"
        version="VideoLAN.VLCPlugin.2"
        autoplay="yes"
        loop="no"
        controls="false"
        target="${this.rtspUrlValue}">
      </embed>
    </object>
    `;

  }


  headerBuild(headerElement, name) {
    headerElement.className = 'd-flex justify-content-between align-items-center'
    let header = document.createElement("h4");
    header.className = 'd-block'
    header.innerText = name;
    headerElement.appendChild(header)
  }

  linkBuild(link) {
    link.className = 'btn btn-sm btn-outline-primary mb-2 mt-2';
    const icon = document.createElement('i');
    icon.className = 'fas fa-share';
    link.append(
      document.createTextNode(this.exportButtonValue + ' '),
      icon
    );
  }


  linkExportBuild(link, params) {
    link.href = `/cctv/camera_exports/new_export?${params.toString()}`
    link.setAttribute("data-turbo", "true");
    link.setAttribute("data-turbo-frame", "modal");
    link.setAttribute("data-turbo-prefetch", "false");
  }

  replyBuild(link, replyUrlValue) {
    link.setAttribute('data-controller', 'cctv--popup')
    link.setAttribute('data-action', 'click->cctv--popup#open')
    link.setAttribute('data-cctv--popup-url-value', replyUrlValue)
    link.className = 'btn btn-sm btn-outline-primary mb-2 mt-2';
    link.innerHTML = '<i class="fas fa-reply"></i> ';
  }

  appendReplyBlock(headerElement, replyUrlValue) {
    const replyBlock = document.createElement('div');
    const link = document.createElement('a');

    this.replyBuild(link, replyUrlValue);
    replyBlock.appendChild(link);
    headerElement.appendChild(replyBlock);
  }

  infoFill(infoElement, text) {
    infoElement.innerText = text;
    infoElement.className = 'alert alert-info text-center d-flex align-items-center justify-content-center py-5';
    infoElement.classList.remove('d-none');
    infoElement.classList.add('d-block');
  }

  removeContainerFromDOM() {
    if (!this.container) return

    const parent = this.container.parentNode
    if (parent) parent.removeChild(this.container)

    this.container = null
  }

  clear() {
    if (this.player) {
      try {
        this.player.pause()
      } catch (e) {
      }
      try {
        this.player.destroy()
      } catch (e) {
      }
      this.player = null
    }
  }


  disconnect() {
    super.disconnect();
    this.clear()
    this.removeContainerFromDOM()
  }

}
